<template>
  <div>
    <v-card outlined tile elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="pa-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">
            Identifiants
          </div>
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-if="loading">
          <v-progress-linear indeterminate color="primary" />
          <v-skeleton-loader class="mb-4" type="table-heading, table-tbody" />
        </div>
        <div v-else v-show="showCard">
          <v-card-text class="d-flex flex-wrap grey lighten-4">
            <component
              :is="projectForm"
              :content="editableIdentifiantsContent"
              :disabled="digitalAccountProcessDisabled"
              :content-altered-values="contentAlteredValues"
            />
          </v-card-text>

          <span v-if="isIdentifiantsEdited">
            <v-divider />
            <v-card-text class="d-flex justify-end">
              <v-btn :disabled="loading" color="secondary" elevation="0" class="mx-2 px-4" @click="saveIdentifiantsCustomer()">
                <v-icon class="mr-3">mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-text>
          </span>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import IdentifiantsForm from '@/components/forms/IdentifiantsForm';
import IdentifiantsFormLB from '@/components/forms/IdentifiantsFormLB';
import { requests } from '@/mixins/index';
import { EventBus } from '../../mixins';

export default {
  name: 'IdentifiantsCard',
  components: {
    IdentifiantsForm,
    IdentifiantsFormLB
  },
  props: {
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [requests],
  data () {
    return {
      loading: false,
      showCard: true,
      editableIdentifiantsContent: JSON.parse(JSON.stringify(this.content))
    };
  },
  computed: {
    digitalAccountProcessDisabled () {
      return !!this.content.digital_account;
    },
    isIdentifiantsEdited () {
      return !!this.content.digital_account !== !!this.editableIdentifiantsContent.digital_account || (typeof (this.editableIdentifiantsContent.digital_account) === 'string' && !this.content.digital_account);
    },
    projectForm () {
      switch (this.$store.getters.getBrand) {
        case 'crm':
          return 'IdentifiantsForm';
        case 'crm_labalaguere':
          return 'IdentifiantsFormLB';
        default:
          return 'IdentifiantsForm';
      }
    }
  },
  watch: {
    content (newContent) {
      this.editableIdentifiantsContent = JSON.parse(JSON.stringify(newContent));
    }
  },
  methods: {
    async saveIdentifiantsCustomer () {
      this.loading = true;
      
      if (this.editableIdentifiantsContent.digital_account) {
        const response = await this.enableCustomerDigitalAccount(this.content.uuid);

        let type = 'success';
        let message = 'Compte digital activé avec succès';

        if (!response.success) {
          this.editableIdentifiantsContent.digital_account = false;
          type = 'danger';
          message = "Erreur lors de l'activation du compte digital";
        }

        this.content.digital_account = !!this.editableIdentifiantsContent.digital_account;

        const notification = {
          message: message,
          type: type,
          timeout: 16000
        };

        EventBus.$emit('show-notifications', [notification]);
        
      }
      this.loading = false;
    }
  }
};

</script>
